<script>
  import Constants from "../Constants";

  export let level;
  export let exp;
  $: progressRate = calcProgressRate(exp);

  /**
   * 次のレベルアップまでの進捗率を計算
   * @param currentExp 現在の経験値
   * @returns 進捗率
   */
  const calcProgressRate = (currentExp) => {
    if (level === 15) {
      return 0;
    }
    const startExp = Constants.EXP_TABLE[level - 1];
    const goalExp = Constants.EXP_TABLE[level];
    const expDiff = goalExp - startExp;
    return (
      100 - Math.floor(((expDiff - (currentExp - startExp)) / expDiff) * 100)
    );
  };

  Constants.EXP_TABLE;
</script>

<div class="container">
  <div class="lv-container">
    <span>Lv.</span>
    <span class="lv">{level}</span>
  </div>
  <div class="progress-container">
    <div class="progress">
      <div class="value" style={`width:${progressRate}%;`} />
    </div>
  </div>
</div>

<style lang="scss">
  .container {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .lv-container {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 5px;
    font-size: 1.1rem;
  }
  .progress-container {
    width: 100%;
    .progress {
      width: 100%;
      height: 24px;
      border-radius: 6px;
      border: 6px solid rgb(180, 180, 180);
      background-color: rgb(32, 32, 32);
      .value {
        height: 100%;
        background-color: rgb(255, 160, 120);
      }
    }
  }

  .lv {
    font-weight: bold;
    font-size: 1.3rem;
  }
</style>
